import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api/client";

export default function LoginPage() {
  const navigate = useNavigate();

  const [userid, setUserID] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  async function handleLogin(e) {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const res = await api.post("/api/auth/login", {
        userid,
        password,
      });

      const data = res?.data;

      // ✅ MINIMUM VALIDATION (backend-agnostic)
      if (!data) {
        throw new Error("Invalid login response");
      }

      /**
       * Normalize user object so the rest of the app
       * has a stable structure regardless of backend shape
       */
      const user = data.user ?? {
        userid: data.userid,
        role: data.role,
        screens: data.screens || [],
      };

      // ✅ Persist auth state
      if (data.token) {
        localStorage.setItem("token", data.token);
      }

      localStorage.setItem("user", JSON.stringify(user));

      // ✅ Navigate after successful auth
      navigate("/menu");
    } catch (err) {
      console.error("LOGIN ERROR:", err);

      if (err.message === "Invalid login response") {
        setError("Login configuration error. Please contact IT support.");
      } else if (err.response?.data?.message) {
        setError(err.response.data.message);
      } else {
        setError("Unable to login. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={styles.pageContainer}>
      <div style={styles.loginContainer}>
        <h2 style={styles.header}>Login</h2>

        {error && <div style={styles.error}>{error}</div>}

        <form onSubmit={handleLogin}>
          <div style={styles.inputGroup}>
            <label style={styles.label}>UserID</label>
            <input
              type="text"
              required
              value={userid}
              onChange={(e) => setUserID(e.target.value)}
              style={styles.inputField}
              autoFocus
            />
          </div>

          <div style={styles.inputGroup}>
            <label style={styles.label}>Password</label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={styles.inputField}
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            style={{
              ...styles.submitBtn,
              backgroundColor: loading ? "#bdbdbd" : "#e53935",
              cursor: loading ? "not-allowed" : "pointer",
            }}
          >
            {loading ? "Signing in..." : "Login"}
          </button>
        </form>
      </div>
    </div>
  );
}

/* ================= STYLES ================= */

const styles = {
  pageContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "100vh",
    backgroundColor: "#f5f6fb",
    padding: "2rem",
  },
  loginContainer: {
    backgroundColor: "#ffffff",
    padding: "2rem",
    borderRadius: "1rem",
    boxShadow: "0 4px 15px rgba(0, 0, 0, 0.1)",
    width: "100%",
    maxWidth: "400px",
  },
  header: {
    fontSize: "2rem",
    fontWeight: "600",
    color: "#e53935",
    textAlign: "center",
    marginBottom: "1.5rem",
  },
  error: {
    color: "#e53935",
    textAlign: "center",
    fontSize: "0.875rem",
    marginBottom: "1rem",
  },
  inputGroup: {
    marginBottom: "1.5rem",
  },
  label: {
    fontSize: "1rem",
    color: "#6E6F70",
    marginBottom: "0.5rem",
    display: "block",
    fontWeight: 500,
  },
  inputField: {
    width: "100%",
    padding: "0.75rem",
    border: "1px solid #ccc",
    borderRadius: "0.5rem",
    fontSize: "1rem",
  },
  submitBtn: {
    width: "100%",
    padding: "1rem",
    color: "white",
    fontWeight: "600",
    borderRadius: "0.75rem",
    border: "none",
  },
};
